export default __webpack_public_path__ + "static/media/01.3be58610.jpg";